"use client";

import { captureException } from "@pex/observability/client";
import { useEffect } from "react";

export default function PaymentError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4">
      <h2 className="font-semibold text-xl">Something went wrong</h2>
      <button
        className="rounded-lg bg-primary px-4 py-2 text-primary-foreground text-sm"
        onClick={reset}
        type="button"
      >
        Try again
      </button>
    </div>
  );
}
